import { Flex, Link, Text } from "@chakra-ui/react";
import { Link as RouterLink } from "react-router-dom";
import { t } from "i18next";
import { useAccountData } from "../../hooks/useAccountData";
import { setFunnelModalConfig } from "../funnel/FunnelModal";
import { FUNNEL_TYPES } from "../funnel/utils/contants";
import { FunnelContextArea } from "../funnel/types";
import { ShieldCheckIcon } from "../icons/ShieldCheckIcon";

export function SafeSearchNotice() {
  const accountData = useAccountData();
  const isAuthenticated = !!accountData?.user;

  return (
    <Flex align="center" gap="12px" borderRadius="12px">
      <ShieldCheckIcon boxSize="24px" color="warning.500" flexShrink={0} />
      <Flex align="center" gap="8px" whiteSpace="nowrap">
        <Text
          fontFamily="'Roboto', sans-serif"
          fontSize="16px"
          fontWeight="400"
          lineHeight="20px"
          color="neutral.300"
        >
          {t("screens.search.safeModeIsOn")}
        </Text>
        {isAuthenticated ? (
          <Link
            as={RouterLink}
            to="/settings/account"
            fontFamily="'Roboto', sans-serif"
            fontSize="14px"
            lineHeight="20px"
            color="blaze.300"
            textDecoration="underline"
            _hover={{ color: "blaze.200" }}
          >
            {t("screens.search.updatePreferences")}
          </Link>
        ) : (
          <Link
            as="button"
            fontFamily="'Roboto', sans-serif"
            fontSize="14px"
            lineHeight="20px"
            color="blaze.300"
            textDecoration="underline"
            _hover={{ color: "blaze.200" }}
            onClick={() =>
              setFunnelModalConfig({
                type: FUNNEL_TYPES.signup,
                context: { modalContext: FunnelContextArea.safeSearch },
              })
            }
          >
            {t("screens.search.updatePreferences")}
          </Link>
        )}
      </Flex>
    </Flex>
  );
}
